const defaultItem = {
  type: 'Select',
  name: 'column_value',
  single_line: true,
  required: true,
  options: [],
  formItemProps: {
    label: '值'
  }
}
const defaultTypeItem = {
  type: 'Select',
  name: 'column_type',
  options: [],
  single_line: true,
  required: true,
  formItemProps: {
    label: '编辑字段',
    initialValue: ''
  }
}
export const getFormItems = ({
  name,
  typeItem = defaultTypeItem,
  item = defaultItem,
  onChange
}: any) => [
  {
    ...typeItem,
    elementProps: {
      onChange,
      showSearch: true
    }
  },
  {
    ...item,
    name
  }
]
